export const navLinks = [
  {
    label: 'Skillset',
    pathname: '/',
    hash: '#project-1',
  },
  {
    label: 'Me',
    pathname: '/',
    hash: '#details',
  },
  // {
  //   label: 'Articles',
  //   pathname: '/articles',
  // },
  {
    label: 'Contact',
    pathname: '/contact',
  },
];

export const socialLinks = [
  {
    label: 'Instagram',
    url: 'https://www.instagram.com/kabilanx_19/',
    icon: 'twitter',
  },
  {
    label: 'Fiverr',
    url: 'https://www.fiverr.com/assassinscreedr/build-cross-platform-mobile-apps-with-amazing-ui-with-flutter',
    icon: 'figma',
  },
  {
    label: 'Github',
    url: 'https://github.com/kabilan235',
    icon: 'github',
  },
];
